import React, { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserContext } from './TokenAuthenticator';

export default function Header() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  return (
    <header className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center min-h-[64px]">
        <h1 className="text-2xl font-bold cursor-pointer" onClick={() => navigate('/')}>Draw</h1>
        {user && (
          <Link to="/profile" className="text-white hover:text-gray-300 flex items-center">
            <span className="mr-2 hidden sm:inline">{user.email}</span>
            <i className="bi bi-person-circle text-2xl"></i>
          </Link>
        )}
      </div>
    </header>
  );
}
